import {noop, shuffleArray, randomInt} from "./playUtil.es6";
import {arrayLastIndexOfP} from "./arrayUtil.es6";

// const log = console.log;
const log = noop;

class CardStatus {
    constructor(card, status) {
        this.card = card;
        this.status = status;
    }
}

class CardTaker {
    /**
     * @param {Array} array
     * @param {Boolean} random
     */
    constructor(array, random) {
        this.array = array;
        this.random = random;
    }

    /**
     * @param size
     * @returns Array
     */
    take(size) {
        let out = [];
        if (this.random) {
            while (this.array.length > 0 && out.length < size) {
                const index = randomInt(this.array.length);
                out = out.concat(this.array.splice(index, 1));
            }

        } else {
            out = this.array.splice(0, size);
        }
        return out;
    }

    all() {
        return this.take(this.array.length);
    }
}

/**
 * Процедура обучения такая.
 *
 * 1) берем слайс (подмножество) карт из 10 штук. В нем должны быть 6 - remaining, 4 - familiar. сортируем по возрастанию знакомости
 * 2) берем первую карту и получаем ответ
 * 2a) после неправильного ответа: сдвигаем на 4 позиции дальше по очереди.
 * 2b) если ответ правильный, то возможен переход карты в другую категорию
 * 3a) если она переходит remaining->familiar, то ставим ее на позицию после последнего familliar (если есть и минимум 3),
 * 3b) если она переходит familiar->mastered, выкидываем её из слайса и берем следующего кандидата и ставим в конец слайса.
 * 4)  кандидат - это remaining (если есть), либо familiar (если есть), либо уж что осталось
 */
export class PackLearnQueue {
    /**
     * @param {object} params
     */
    constructor({progress, dropMastered, fullRandom}) {
        this.progress = progress;
        this.dropMastered = !!dropMastered;
        this.fullRandom = fullRandom;

        /**
         * @type {CardStatus[]}
         */
        this.queue = [];

        this.sliceSize = 10;
    }

    init() {
        const cards = this.progress.getStatusMap();
        const cardsCount = cards.mastered.length + cards.familiar.length + cards.remaining.length;

        this.sliceSize = Math.min(10, cardsCount);

        const takeFamiliar = Math.min(cards.familiar.length, Math.floor(this.sliceSize * .4));
        const takeRemaining = Math.min(cards.remaining.length, this.sliceSize - takeFamiliar);

        const familiarCards = new CardTaker(cards.familiar, this.fullRandom);
        const remainingCards = new CardTaker(cards.remaining, this.fullRandom);
        const masteredCards = new CardTaker(cards.mastered, this.fullRandom);

        let queue = [];
        if (takeFamiliar > 0) {
            const sub = familiarCards.take(takeFamiliar)
                .map(c => new CardStatus(c, 'familiar'));
            queue = queue.concat(sub);
        }
        if (takeRemaining > 0) {
            const sub = remainingCards.take(takeRemaining)
                .map(c => new CardStatus(c, 'remaining'));
            queue = queue.concat(sub);
        }
        if (queue.length < this.sliceSize) {
            const takeMastered = Math.min(cards.mastered.length, this.sliceSize - queue.length);
            const sub = masteredCards.take(takeMastered)
                .map(c => new CardStatus(c, 'mastered'));
            queue = queue.concat(sub);
        }

        shuffleArray(queue);

        // стратовый набор готов. теперь добавляем остальные

        queue = queue.concat(remainingCards.all().map(c => new CardStatus(c, 'remaining')));
        queue = queue.concat(familiarCards.all().map(c => new CardStatus(c, 'familiar')));
        queue = queue.concat(masteredCards.all().map(c => new CardStatus(c, 'mastered')));

        this.queue = queue;
    }

    current() {
        log(this.queue.slice(0, this.sliceSize).map(item => `${item.card}:${item.status}`));
        return this.queue[0].card;
    }

    /**
     * @param {Array} array
     * @param {Number} n
     * @returns {Array}
     * @private
     */
    _takeN(array, n) {
        if (array.length <= n) {
            return array.splice(0, array.length);
        }

        if (this.fullRandom) {
            const indices = new Set();
            while (indices.size < n) {
                const i = randomInt(array.length);
                if (!indices.has(i)) {
                    indices.add(i);
                }
            }
        } else {
            return array.splice(0, n);
        }
    }

    /**
     * @param {boolean} success
     */
    next(success) {
        const current = this.queue[0];

        if (!success) {
            this._swap(0, 3);
            return;
        }

        // const lastStatus = current.status;
        current.status = this.progress.getStatus(current.card);
        if (current.status === 'mastered' && this.dropMastered) {
            this.queue.shift();
            return;
        }

        let swapTo = this.sliceSize - 1;
        if (current.status === 'mastered') {
            swapTo = this.queue.length - 1;
        } else if (current.status === 'familiar') {
            const lastFamiliar = arrayLastIndexOfP(this.queue.slice(0, this.sliceSize), item => {
                return item.status === 'familiar';
            });
            if (lastFamiliar > 0) {
                swapTo = Math.max(lastFamiliar, 3);
            }
        }

        this._swap(0, swapTo);
    }

    _swap(from, to) {
        const toIndex = Math.min(to, this.queue.length - 1);
        const removed = this.queue.splice(from, 1);
        this.queue.splice(toIndex, 0, removed[0]);
    }
}
